import React from'react';
import { Loader2 } from'lucide-react';

/**
 * Full-page centered loading spinner. Use to gate page content while the
 * primary query for a route is in its initial load (isPending in v5 of
 * react-query). Keeps the page header/breadcrumbs visible above it so the
 * layout doesn't jump when data resolves.
 *
 * Props:
 * - message: optional text under the spinner (default"Loading…")
 * - minHeight: tailwind min-h-* class to reserve vertical space
 * (default"min-h-[400px]")
 */
export default function PageLoader({ message ='Loading…', minHeight ='min-h-[400px]' }) {
 return (
 <div
 className={`flex flex-col items-center justify-center ${minHeight} w-full text-gray-500`}
 role="status"
 aria-live="polite"
 >
 <Loader2 className="w-8 h-8 animate-spin text-brand-600" />
 {message && <p className="mt-3 text-sm">{message}</p>}
 </div>
 );
}

/**
 * Smaller inline spinner for use inside chart cards / tables that are
 * gated by a sub-query (e.g. when a user selects a row and a detail
 * panel needs to load).
 */
export function InlineLoader({ message, className ='' }) {
 return (
 <div
 className={`flex items-center justify-center gap-2 py-8 text-sm text-gray-500 ${className}`}
 role="status"
 aria-live="polite"
 >
 <Loader2 className="w-4 h-4 animate-spin" />
 {message && <span>{message}</span>}
 </div>
 );
}
